import { render, staticRenderFns } from "./ProposalShowDetailsRow.vue?vue&type=template&id=09dfd34d&scoped=true&"
import script from "./ProposalShowDetailsRow.vue?vue&type=script&lang=js&"
export * from "./ProposalShowDetailsRow.vue?vue&type=script&lang=js&"
import style0 from "./ProposalShowDetailsRow.vue?vue&type=style&index=0&id=09dfd34d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dfd34d",
  null
  
)

export default component.exports